import { Skeleton } from '@mui/material';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

export function GatewayRulesFormSkeletonMappingItem() {
  return (
    <Box sx={{ display: 'flex', gap: 2, width: '100%', mb: '22px' }}>
      <Box width="100%">
        <Box display="flex" gap={2} mb={1} width="100%">
          <Skeleton height={40} sx={{ flexGrow: 1 }} variant="rounded" />
          <Skeleton height={40} sx={{ flexGrow: 1 }} variant="rounded" />
          <Skeleton height={40} sx={{ maxWidth: '240px', width: '100%' }} variant="rounded" />
        </Box>
        <Stack direction="row" gap={2} sx={{ mt: 3 }}>
          <Skeleton height={40} sx={{ flexGrow: 1 }} variant="rounded" />
          <Skeleton height={40} sx={{ maxWidth: '240px', width: '100%' }} variant="rounded" />
        </Stack>
      </Box>
      <Skeleton height={24} sx={{ mt: '20px' }} variant="rounded" width={24} />
    </Box>
  );
}
